export const AdministrationService = {
    async getApplications() {
        const data = [
            {
                id: "1",
                status: "Pending",
                applicationDate: new Date(2020, 5, 20),
                companyName: "PTA",
                contactPerson: "Luka Cetina",
                email: "l.cetina@pta.hr",
            },
            {
                id: "2",
                status: "Pending",
                applicationDate: new Date(2020, 6, 18),
                companyName: "TestCompany1",
                contactPerson: "Miki Manojlović",
                email: "m.manojlovic@pta.hr",
            },
            {
                id: "3",
                status: "Approved",
                companyName: "TestCompany2",
                applicationDate: new Date(2020, 6, 21),
                contactPerson: "Denis Manojlović",
                email: "d.manojlovic@pta.hr",
            },
            {
                id: "4",
                status: "Declined",
                companyName: "TestCompany3",
                applicationDate: new Date(2020, 6, 17),
                contactPerson: "Ivan Manojlović",
                email: "i.manojlovic@pta.hr",
            },
        ];

        return data;
    },
};
